import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c745996"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }

import { ListaJugador } from "@/interfaces/Lista";
import { ref, computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalVerLista',
  props: {
    isVisible: { type: Boolean },
    listaJugador: {}
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = computed({
  get: () => props.isVisible,
  set: (val: boolean) => emit("update:isVisible", val),
});

const isLoading = ref(false);
const imageBase64 = ref<string>();
const nick = ref<string>();
const ejercito = ref<string>();

const cargarLista = () => {
  isLoading.value = true;
  try {
    imageBase64.value = props.listaJugador.listaData;
    nick.value = props.listaJugador.nick;
    ejercito.value = props.listaJugador.nombreEjercito;
  } catch (error) {
    console.error("Error al cargar la lista", error);
  } finally {
    isLoading.value = false;
  }
};

const close = () => {
  emit("update:isVisible", false);
};

// Re-cargar datos cada vez que se abre el modal
watch(visible, (newVal) => {
  if (newVal) {
    cargarLista();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, "Lista de " + _toDisplayString(nick.value), 1),
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: close,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (imageBase64.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_v_list, { dense: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(ejercito.value), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("img", {
                            src: imageBase64.value,
                            alt: "Lista cargada",
                            class: "uploaded-image"
                          }, null, 8, _hoisted_4)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, "No se encontró una lista."))
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "tonal",
                color: "secondary",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cerrar")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})